const Loadable = (Component: React.ComponentType<any>) => (props: any) => <Component {...props} />;

export default Loadable;
